import axios from 'axios';

const TierService = {
  listPublic: () => axios.get('/tiers'),
  listAdmin: () => axios.get('/super-admin/tiers'),
  create: (payload) => axios.post('/super-admin/tiers', payload),
  update: (id, payload) => axios.patch(`/super-admin/tiers/${id}`, payload),
  remove: (id) => axios.delete(`/super-admin/tiers/${id}`),
};

export default TierService;

